module.exports = __webpack_public_path__ + "static/media/ChevronUp.419ac9bb.svg";